/** @format */

import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Grid, Button, Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useBusinessDispatcher, useQuery, useBusiness } from 'hooks';
import { SimpleDialog, ButtonLoading, PageContainer, TabKeeper, LoadingPage, Icons } from 'components';
import jMoment from 'moment-jalaali';
import { useNavigate, useLocation } from 'react-router-dom';
import createToast from 'components/Toast/Toast';
import persianJs from 'persianjs';
import validator from 'validator';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import {
  updateBusinessService,
  businessSettingService,
  businessSituationGetService,
  businessOwnerGetService,
  businessOwnerPutService,
} from './services/BusinessServices';
import {
  BaseInfo,
  ContactUs,
  AgentInfo,
  OwnerInfo,
  UpgradeCondition,
  UpgradeInstruction,
} from './components';
import BUSINESS_TYPES from './constants/businessTypes';

// TODO: If images (logo and cover) confirmed right after selection, it shows an alert with mean of: image is not selected!!!
// TODO: If getOwner faces error after business owner change, status of owner info fields are not changed!!!!!

export const getFinancialLevelNumber = (levelString) => {
  if (!levelString) return 0;

  const levels = {
    USER_FINANCIAL_LEVEL_CELLPHONE_VERIFIED: 1,
    USER_FINANCIAL_LEVEL_CELLPHONE_NATIONALCODE_VERIFIED: 2,
    USER_FINANCIAL_LEVEL_IDENTITY_VERIFIED: 3,
    USER_FINANCIAL_LEVEL_NATIONAL_CARD_IMAGE_VERIFIED: 4,
    USER_FINANCIAL_LEVEL_PHYSICAL_VERIFIED: 5,
  };
  return levels[levelString] ?? 0;
};

//* * constants */
const tabsFields = {
  baseInfo: [
    'name',
    'economicCode',
    'registrationNumber',
    'nationalCode',
    'sheba',
    'description',
    'logoImage',
    'coverImage',
    'legalInfo.shopName',
    'legalInfo.shopNameEn',
  ],
  contactUs: [
    'state',
    'city',
    'address',
    'postalcode',
    'phone',
    'fax',
    'legalInfo.website',
    'email',
  ],
  agentInfo: ['agent.firstName', 'agent.lastName', 'agent.nationalCode', 'agent.cellphoneNumber'],
  ownerInfo: [
    'owner.username',
    'owner.firstName',
    'owner.lastName',
    'owner.cellphoneNumber',
    'owner.nationalCode',
    'owner.birthDate',
  ],
  document: [],
};
const titlesTabs = {
  baseInfo: 'اطلاعات کسب‌وکار',
  contactUs: 'اطلاعات تماس',
  agentInfo: 'اطلاعات هویتی نماینده',
  ownerInfo: 'اطلاعات هویتی مالک',
};
const tabEnKeys = new Set(['base', 'contact', 'agent', 'owner']);
// We use it for counting number of errors in each tabs
const INIT_TABS_ERRORS_COUNT = [0, 0, 0, 0, 0];

//* * main component */
const Business = () => {
  //* * STATE */

  const [loading, setLoading] = useState(false);
  const [requestLoading] = useState(false);
  const [loadingOwner, setLoadingOwner] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const [dialogContent, setDialogContent] = useState({
    title: '',
    content: '',
  });

  const [, setBizTitle] = useState('');
  const [isLegal, setIsLegal] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const [statusBiz, setStatusBiz] = useState(null);
  const [, setHint] = useState({
    businessPromotionTerms: true,
  });

  const [city, setCity] = useState('');
  const [cityId, setCityId] = useState('');

  const [province, setProvince] = useState('');
  const [provinceId, setProvinceId] = useState('');

  const [managerMsg, setManagerMsg] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [openPromotionDialog, setOpenPromotionDialog] = useState(false);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [, setAllowRequest] = useState(false);
  const [images, setImages] = useState({ logo: null, cover: null });
  const [tabsErrors, setTabsErrors] = useState(INIT_TABS_ERRORS_COUNT);

  // Owner Info
  const [birthDateOwner, setBirthDateOwner] = useState();
  const [ownerFinancialLevel, setOwnerFinancialLevel] = useState(null);
  const [currentOwner, setCurrentOwner] = useState(null); // To show on Change Owner part
  const [newOwnerId, setNewOwnerId] = useState(null);
  const [showChangingOwner, setShowChangingOwner] = useState(false);
  //* * HOOKS */
  const classes = useStyles();
  const methods = useForm();
  const setBusinessDispatcher = useBusinessDispatcher();
  const navigate = useNavigate();
  const query = useQuery();
  const businessInfo = useBusiness();
  const location = useLocation();
  const [copyName, setCopyName] = useState(null);
  const [myInterval, setMyInterval] = useState(null);
  const [isOpenChangeNameDG, setIsOpenChangeNameDG] = useState(false);
  const { handleSubmit, reset, formState: { errors } } = methods;

  const [latitude, setLatitude] = useState({
    lat:
      businessInfo.latitude === 0 || businessInfo.latitude === undefined
        ? 35.72847264171851
        : businessInfo.latitude,
    lng:
      businessInfo.longitude === 0 || businessInfo.longitude === undefined
        ? 51.82519197463989
        : businessInfo.longitude,
  });

  useEffect(() => {
    calculateTabsErrosCount(errors);
    if (errors && Object.keys(errors).length > 0) createToast('خطا', errorsToStr(errors), 'danger');
  }, [errors]);

  useEffect(() => {
    const newTabIndex = !query.get('tab') ? 0 : [...tabEnKeys].indexOf(query.get('tab'));
    if (newTabIndex >= 0) {
      setActiveTab(newTabIndex < 0 ? 0 : newTabIndex);
    }
  }, [query]);

  useEffect(() => {
    //getSettings();
    if (actionsList['contentBusinessPage'] || actionsList['updateBusinessDashboardBtn']) {
      onBusinessInfoChange(businessInfo);

    }
  }, [businessInfo]);

  useEffect(() => {
    checkBusseissinfo();
  }, []);
  useEffect(() => {
    copyName && clearInterval(myInterval);
  }, [copyName]);
  const checkBusseissinfo = () => {
    setMyInterval(
      setInterval(() => {
        if (methods.watch('name')) {
          setCopyName(methods.watch('name'));
        } else {
        }
      }, 1000),
    );
  };

  //* * API REQUESTS */

  const onSubmit = (data) => {
    data = { ...originalData, ...data };
    if (originalData?.owner) {
      data.ownerId = originalData.owner.id;
    }
    if (data?.agent?.nationalCode === '' && data.agent?.cellphoneNumber) {
      createToast('خطا', 'کد ملی را وارد نمایید.', 'danger');
      return;
    }
    if (data?.agent?.cellphoneNumber === '' && data.agent?.nationalCode) {
      createToast('خطا', 'اطلاعات نمایندگان باید کامل وارد شود.', 'danger');
      return;
    }

    if (newOwnerId) {
      data.ownerId = newOwnerId;
    }
    const dataApi = {
      ...data,
      city : data?.city?.label,
      cityId : data?.city?.id,
      state: data?.state?.label,
      stateId: data?.state?.id,
      country: 'ایران',
      countryId: 1,
      logoImage: images?.logo,
      coverImage: images?.cover,
      businessName: data.name,
      bizId: data.id,
      agentFirstName: data.agent?.firstName,
      agentLastName: data.agent?.lastName,
      agentCellphoneNumber: data?.agent?.cellphoneNumber,
      agentNationalCode: data?.agent?.nationalCode,
      guildCode: data?.guilds.map((item) => item.code),
      tags: data.tags ?? [],
      tagTrees: data.tagTrees ?? [],
      website: data?.legalInfo?.website,
      shopName: data?.legalInfo?.shopName ?? null,
      shopNameEn: data?.legalInfo?.shopNameEn ?? null,
      fax: data?.faxNumber,
      postalCode: data?.postalcode,
      changeAgent: data.agent?.firstName ? true : false,
      changeLogo: images?.logo !== originalData?.image,
      changeCover: images?.cover !== originalData?.coverImage,
    };

    delete dataApi?.faxNumber;
    delete dataApi?.postalcode;

    ['agent', 'id', 'guilds', 'username'].map((item) => delete dataApi[item]);



    const update = async () => {
      try {
        setLoading(true);
        const res = await updateBusinessService(dataApi);

        setShowChangingOwner(false);

        setBusinessDispatcher({ ...res?.data?.result });

        if (res?.data?.result?.owner && !newOwnerId) {
          if (data?.owner?.birthDate) {
            const birthDateStr = `${data.owner.birthDate}`;
            if (validator.isNumeric(birthDateStr)) {
              const bd = new Date(parseInt(birthDateStr));
              data.owner.birthDate = persianJs(jMoment(bd).format('jYYYY/jMM/jDD'))
                .toEnglishNumber()
                .toString();
            }
          }
          await businessOwnerPutService(data.owner);
        }

        createToast(
          'موفق',
          newOwnerId
            ? 'مالک کسب‌وکار با موفقیت تغییر کرد.'
            : 'اطلاعات کسب‌وکار با موفقیت ویرایش شد.',
          'success',
        );
        setNewOwnerId(null);

        query.get('redirectUrl') && navigate('/BonusCard/List'); // اگر از صفحه بن کارت به این صفحه ریدایکرت شده باشه ، بعد از ویرایش به همون صفحه بازخواهد گشت
      } catch (error) { }
      setLoading(false);
    };

    update();
  };

  const getOwner = async () => {
    try {
      setLoadingOwner(true);
      const { result } = await businessOwnerGetService();

      setCurrentOwner(result);

      setOwnerFinancialLevel(result?.financialLevelSrv?.value);

      const ownerInfo = {
        'owner.username': result.username,
        'owner.firstName': result.firstName,
        'owner.lastName': result.lastName,
        'owner.cellphoneNumber': result.cellphoneNumber ?? result.cellphoneNumber_unverified,
        'owner.nationalCode': result.nationalCode_verified ?? result.nationalCode,
        'owner.birthDate':
          result.birthDate > 0
            ? result.birthDate
            : result?.legalInfoBirthDate
              ? jMoment(result?.legalInfoBirthDate, 'jYYYY/jM/jD')
              : null,
      };

      setBirthDateOwner(result.birthDate);
      setLoadingOwner(false);
      return ownerInfo;
    } catch (error) {
      setLoadingOwner(false);
      return null;
    }
  };

  const getSettings = async () => {
    if (!businessInfo?.hasOwnProperty('active')) return;
    try {
      const resSetting = await businessSettingService();
      if (resSetting.result?.hint) {
        setHint(resSetting.result.hint);
      }
      if (businessInfo.active) {
        setAllowRequest(false);
        setStatusBiz('accepted');
      } else if (!resSetting.result.requested) {
        setStatusBiz('not-accepted'); // for first try
        setAllowRequest(true);
      } else {
        getSituation();
      }
    } catch (e) { }
  };

  const getSituation = async () => {
    try {
      const resSituation = await businessSituationGetService();

      if (resSituation.result?.discussions) {
        setManagerMsg(resSituation.result.discussions[0].DiscussionContent);
        setDialogContent({
          content: resSituation.result.discussions[0].DiscussionContent,
          title: 'پیام مدیر پاد',
        });
        setOpenDialog(true);
      }

      if (resSituation.result.status === 'rejected') {
        setAllowRequest(true);
      }

      setStatusBiz(resSituation.result.status);
    } catch (error) {
      if (error?.response?.status === 400) {
        setAllowRequest(true);
      }
      setStatusBiz('pending');
    }
  };

  //* * OTHER FUNCTIONS */
  const onBusinessInfoChange = async (bizInfo) => {
    if (Object.keys(bizInfo).length) {
      let dataForm = bizInfo;
      const isLegal = checkBusinessIsLegal(bizInfo);

      try {
        setFetching(true);

        if (isLegal) {
          setIsLegal(true);
        }

        setOriginalData(bizInfo);

        setImages({
          logo: bizInfo?.image,
          cover: bizInfo?.coverImage,
        });

        setCity(bizInfo?.city);
        setProvince(bizInfo?.state);

        setBizTitle(bizInfo?.name || 'عنوان کسب‌وکار');

        const resOwner = await getOwner();
        if (resOwner) {
          dataForm = { ...dataForm, ...resOwner };
        }
        setFetching(false);

        reset(dataForm);
      } catch (e) {
        setFetching(false);
      }
    }
  };

  const checkBusinessIsLegal = (businessInfo) => {
    return (
      !!businessInfo?.registrationNumber &&
      !!businessInfo?.nationalCode &&
      !!businessInfo?.economicCode
    );
  };
  const displayManagerMsg = () => {
    setDialogContent({
      content: managerMsg,
      title: 'پیام مدیر پاد',
    });
    setOpenDialog(true);
  };

  const isAgentInfoChanged = (newData) => {
    const keys = [
      { newData: 'agentFirstName', originalData: 'firstName' },
      { newData: 'agentLastName', originalData: 'lastName' },
      { newData: 'agentCellphoneNumber', originalData: 'cellphoneNumber' },
      { newData: 'agentNationalCode', originalData: 'nationalCode' },
    ];
    const newAgentInfo = {};
    keys.forEach(
      (v) =>
      (newAgentInfo[v?.newData] =
        !newData?.[v?.newData] || newData?.[v?.newData] === '' ? null : newData?.[v?.newData]),
    );

    for (const k of keys) {
      if (newAgentInfo?.[k?.newData] !== originalData?.agent?.[k?.originalData]) {
        return true;
      }
    }

    return false;
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };
  const handleClosePromotionDialog = () => {
    setOpenPromotionDialog(false);
  };
  const flattenErros = (errs) => {
    if (!errs) return null;
    if (Object.keys(errs).length === 0) return null;
    let tempErrs = { ...errs };
    if (tempErrs.agent) {
      const agentErrors = { ...tempErrs.agent };
      delete tempErrs.agent;
      tempErrs = { ...tempErrs, ...agentErrors };
    }
    if (tempErrs.owner) {
      const ownerErrors = { ...tempErrs.owner };
      delete tempErrs.owner;
      tempErrs = { ...tempErrs, ...ownerErrors };
    }
    if (tempErrs.legalInfo) {
      const legalInfoErrors = { ...tempErrs.legalInfo };
      delete tempErrs.legalInfo;
      tempErrs = { ...tempErrs, ...legalInfoErrors };
    }
    return tempErrs;
  };

  const calculateTabsErrosCount = (errs) => {
    setTabsErrors([...INIT_TABS_ERRORS_COUNT]);
    if (!errors) {
      setTabsErrors([...INIT_TABS_ERRORS_COUNT]);
      return;
    }

    const tempErrs = flattenErros(errs);

    if (!tempErrs) {
      setTabsErrors(INIT_TABS_ERRORS_COUNT);
      return;
    }

    const newTabsErros = [...INIT_TABS_ERRORS_COUNT];

    // eslint-disable-next-line array-callback-return
    Object.keys(tempErrs).map((v) => {
      // eslint-disable-next-line array-callback-return
      Object.keys(tabsFields).map((tabFields, k) => {
        if (tabsFields[tabFields].includes(tempErrs[v]?.ref?.name)) {
          newTabsErros[k] = newTabsErros[k] + 1;
        }
      });
    });
    setTabsErrors(newTabsErros);
  };

  //* * Local Components */
  const panelsTabs = {
    baseInfo: <BaseInfo images={images} isLegal={isLegal} setImages={setImages} />,
    contactUs: (
      <ContactUs
        city={city}
        setCity={(c) => setCity(c)}
        setCityId={setCityId}
        province={province}
        setProvince={(p) => setProvince(p)}
        setProvinceId={setProvinceId}
        latitude={latitude}
        setLatitude={setLatitude}
        businessInfo={businessInfo}

      />
    ),
    agentInfo: <AgentInfo isLegal={isLegal} businessInfo={businessInfo} />,
    ownerInfo: (
      <OwnerInfo
        // Loadings
        loading={loadingOwner}
        fetchingBusiness={fetching}
        submittingBusiness={loading}
        //unverifiedOwner
        unverifiedOwner={businessInfo?.unverifiedOwner || {}}
        // Other info
        birthDateOwner={birthDateOwner}
        isLegal={isLegal}
        financialLevel={ownerFinancialLevel}
        // disableCellPhone={disableOwnerCellPhoneNumber}
        showChangingOwner={showChangingOwner}
        currentOwner={currentOwner}
        setNewOwnerId={setNewOwnerId}
        onSubmit={handleSubmit(onSubmit)}
        onShowChangeOwner={() => setShowChangingOwner(true)}
        onCancelOwnerChange={() => setShowChangingOwner(false)}
      />
    ),
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" onClick={closeDialog}>
          بستن
        </Button>
      </>
    );
  };

  const errorsToStr = (errs) => {
    if (!errs) return null;

    const tempErrs = flattenErros(errs);

    return (
      <div>
        {Object.keys(tempErrs).map((v) => (
          <li>{tempErrs[v]?.message}</li>
        ))}
      </div>
    );
  };

  const findBizTypeObject = (bizType) => {
    const f = BUSINESS_TYPES.find((t) => t?.code === bizType);
    if (f?.code) return f;
    return null;
  };

  const getBizTypeText = (bizTypeObj) => {
    if (bizTypeObj?.title) return bizTypeObj?.title;

    return '-';
  };

  //* * Local Variables */
  const bizTypeObject = findBizTypeObject(businessInfo?.businessType);
  const actionsList =
    getDynamicObjectAction([
      'contentBusinessPage',
      'newRequestBusinessBtn',
      'updateBusinessDashboardBtn'
    ]);


  // ** Render */
  return (
    <PageContainer
      title="ویرایش اطلاعات کسب‌و‌کار"
      className={classes.root}
      meta={
        <Grid container direction="row" alignItems="center" className={classes.headerContainer}>
          {managerMsg && (
            <>
              <Box m={1}>
                <Button color="primary" onClick={displayManagerMsg}>
                  نمایش پیام مدیر
                </Button>
              </Box>
              <div className={classes.divider} />
            </>
          )}
          {(actionsList['newRequestBusinessBtn'] || actionsList['contentBusinessPage'] || actionsList['updateBusinessDashboardBtn']) && (
            <>
              {/* <BizStatus statusBiz={statusBiz} /> */}

              {
                businessInfo.active && bizTypeObject?.code ? (
                  <>
                    {/* <div className={classes.divider} /> */}
                    <Typography>
                      <b>{getBizTypeText(bizTypeObject)}</b>
                    </Typography>
                  </>
                ) : null
              }
              < div className={classes.divider} />

              <ButtonLoading
                disableElevation
                startIcon={<Icons icon='ShieldSuccess' color="#303D8F" size="25" />}
                color="primary"
                variant="outlined"
                className={classes.requestBtn}
                loading={requestLoading}
                name="درخواست تایید یا ارتقا"
                onClick={() => {
                  if (businessInfo.active) {
                    setOpenPromotionDialog(true);
                  } else {
                    navigate('/NewRequestConfirmation');
                  }
                }}
              />
            </>

          )}
        </Grid>
      }
      breadcrumbs={constBreadCrumbsTitle.BUSINESS_INFO}
    >
      <>
        {/* Modals */}
        <SimpleDialog
          title="شرایط ارتقای کسب‌وکار"
          open={isUpgradeModalOpen}
          onClose={() => setIsUpgradeModalOpen(false)}
        >
          <UpgradeInstruction
            bizTypeCode={findBizTypeObject(businessInfo?.businessType)?.code}
            bizOwnerLevel={ownerFinancialLevel}
            isActive={businessInfo?.active}
          />
        </SimpleDialog>
        <SimpleDialog
          title="شرایط ارتقای کسب‌وکار"
          open={isUpgradeModalOpen}
          onClose={() => setIsUpgradeModalOpen(false)}
        >
          <UpgradeInstruction
            bizTypeCode={findBizTypeObject(businessInfo?.businessType)?.code}
            bizOwnerLevel={ownerFinancialLevel}
            isActive={businessInfo?.active}
          />
        </SimpleDialog>
        <SimpleDialog
          title={dialogContent.title}
          open={openDialog}
          labelButton="متوجه شدم"
          onClose={closeDialog}
          actions={<ActionsBtn />}
        >
          <UpgradeCondition />
        </SimpleDialog>

        {/* Main Form */}
        {(actionsList['contentBusinessPage'] || actionsList['updateBusinessDashboardBtn']) && (
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Form Container */}
              <Grid container>
                {/* Form Tabs */}
                {fetching ? (
                  <LoadingPage />
                ) : (
                  <TabKeeper
                    onSelect={(v) => {
                      navigate({
                        pathname: location.pathname,
                        search: `?tab=${[...tabEnKeys][v]}`,
                      });
                    }}
                    selectedIndex={activeTab}
                    titles={Object.keys(titlesTabs).map((item) => titlesTabs[item])}
                    tabsErrors={tabsErrors}
                    panels={Object.keys(panelsTabs).map((item) => panelsTabs[item])}
                  />
                )}

                {/* onChanging Owner */}
                {!showChangingOwner ? (
                  <Grid container item xs={12} className={classes.submitContainer}>
                    <div className={classes.containButton}>
                      <ButtonLoading
                        type="submit"
                        variant="contained"
                        color="primary"
                        loading={loading}
                        name="ذخیره اطلاعات"
                      />

                    </div>
                  </Grid>
                ) : null}
              </Grid>
            </form>
          </FormProvider>
        )}
      </>

      <SimpleDialog
        title="ارسال درخواست جدید"
        open={openPromotionDialog}
        onClose={handleClosePromotionDialog}
        actions={
          <Grid container>
            <Grid item xs={12} className={classes.btnContainer}>
              <Button color="primary" variant="contained" onClick={handleClosePromotionDialog}>
                بستن
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography align="left">کسب و کار شما قبلا تایید شده است!</Typography>
          </Grid>
        </Grid>
      </SimpleDialog>

      <SimpleDialog fullWidth maxWidth="sm" open={isOpenChangeNameDG} title="ویرایش نام کسب و کار">
        <Grid container style={{ textAlign: 'justify' }}>
          <div>
            شما اجازه ویرایش نام کسب و کار را ندارید. درخواست ویرایش نام به تیم ساپورت ارسال شد و
            مراتب متعاقبا به شما اعلام خواهد شد.
          </div>
        </Grid>
        <Grid style={{ display: 'flex', marginTop: '16px', flexDirection: 'row-reverse' }}>
          <Button
            variant="contained"
            //color="primary"
            onClick={() => setIsOpenChangeNameDG(false)}
          >
            بستن
          </Button>
        </Grid>
      </SimpleDialog>
    </PageContainer >
  );
};

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    color: '#1a334d',
    marginBottom: 0,
  },
  btn: {
    marginInlineStart: theme.spacing(1),
  },
  notAvailabelBranch: {
    textAlign: 'center',
    padding: theme.spacing(3),
    fontWeight: 'bold',
    fontSize: 15,
  },
  link: {
    color: theme.palette.primary.main,
  },
  btnContainer: {
    display: 'flex',
    marginTop: '16px',
    flexDirection: 'row-reverse',
    gap: '15px',
  },
  wrapIcon: {
    verticalAlign: 'middle',
    display: 'inline-flex',
  },
  tabPanel: {
    padding: '24px 3px',
  },
  containButton: {
    display: 'flex',
    flexDirection: 'row-reverse',
    '& > *': {
      margin: `5px 10px`,
    },
  },
  headerContainer: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  submitContainer: {
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'flex-start',
    justifyContent: 'flex-end',
  },
  fetchingProgress: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 50,
    marginBottom: 50,
  },
  upgradeBtn: {
    marginInlineStart: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    // borderRadius: 30
  },
  divider: {
    height: 25,
    width: 1,
    marginInlineStart: theme.spacing(1.5),
    marginInlineEnd: theme.spacing(1.5),
    background: theme.palette.grey[300],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  requestBtn: {
    marginTop: '0',
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
  },
  upgradeButton: {
    marginInlineEnd: theme.spacing(1),
    border: 'none',
    background: theme.palette.primary.light,
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
      background: theme.palette.primary.light,
      border: 'none',
    },
  },
}));

export default Business;
